import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Card } from 'antd';

interface IProps {
    by_status: {
        paid: number,
        active: number,
        due: number,
        over_due: number,
    }
}

const LoanStatusChart: React.FC<IProps> = ({by_status}) => {
    const clearedPercentage = ((by_status.paid / (by_status.paid + by_status.active + by_status.due + by_status.over_due)) * 100).toFixed(1);

    const options: Highcharts.Options = {
        chart: {
            plotBackgroundColor: '#fff',
            plotBorderWidth: 0,
            plotShadow: false,
            type: 'pie'
        },
        colors: ['#33b559', '#0062ff', '#ff9466', '#fe5e37'],
        title: {
            text: `<span style="font-size: 30px; color: #207a3b;" >${clearedPercentage}%</span><br/><span style="font-size: 18px; color: #207a3b; ">PAID</span>`,
            align: 'center',
            verticalAlign: 'middle',
            y: -10
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },
        series: [{
            type: 'pie',
            name: 'Loans',
            innerSize: '85%',
            borderRadius: 15,
            data: [{
                name: 'Paid',
                y: by_status.paid,
            },  {
                name: 'Active',
                y: by_status.active
            },  {
                name: 'Due',
                y: by_status.due
            }, {
                name: 'Over due',
                y: by_status.over_due
            }]
        }],
        credits:{
            enabled: false
        }
    };

    return (
        <Card bordered style={{border: '1px #00000022 solid'}}>
      <h3 className='text-uppercase font-weight-bold' style={{fontSize: '15px', fontWeight: 'bold'}}>Loans by status</h3>

            <HighchartsReact highcharts={Highcharts} options={options} />
        </Card>
    );
};

export default LoanStatusChart;
